module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_pawcom_m2.b2cf68df81446ea0c3c58a701793b647.png";